import React, { useMemo , useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { ReportAbuseFilter } from "./reportAbuse-filter/ReportAbuseFilter";
import { ReportAbuseTable } from "./reportAbuse-table/ReportAbuseTable";
import { useReportAbuseUIContext } from "./ReportAbuseUIContext";

export function ReportAbuseCard({
  isLoading,
  filterValues,
  handleFilterValues,
  handleAddReportAbuseShow,
  reportAbuseListTotalCount,
  currentPage,
  setCurrentPage,
  handleReset,
  reportAbuseList,
}) {
  const reportAbuseUIContext = useReportAbuseUIContext();
  const reportAbuseUIProps = useMemo(() => {
    return {
      ids: reportAbuseUIContext.ids,
      queryParams: reportAbuseUIContext.queryParams,
      setQueryParams: reportAbuseUIContext.setQueryParams,
      openReceiptDialog: reportAbuseUIContext.openReceiptDialog,
      openDeleteDialog: reportAbuseUIContext.openDeleteDialog,
      openEditDialog: reportAbuseUIContext.openEditDialog,
    };
  }, [reportAbuseUIContext]);
  const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };

  return (
    <>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4 d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">Report Abuses</span>
          </h3>
          <Button
            type="button"
            className="btn btn-secondary btn-lg"
            onClick={onhandleReset}
          >
            Reset
          </Button>
          <Button
            variant="btn btn-light-primary btn-lg d-none"
            onClick={handleAddReportAbuseShow}
          >
            New ReportAbuse
          </Button>
        </Card.Header>
        <Card.Body>
          <ReportAbuseFilter
            filterValues={handleFilterValues}
            handleReset={handleReset}
            myRef={myRef}
          />
          <ReportAbuseTable
            filterValues={filterValues}
            reportAbuseListTotalCount={reportAbuseListTotalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            reportAbuseList={reportAbuseList}
            isLoading={isLoading}
          />
        </Card.Body>
      </Card>
    </>
  );
}
